import { isMemberDetailResponse } from '@urbanik/api-contracts';
export class MemberDetailApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'MemberDetailApiError';
    }
}
export async function getMemberDetail(baseUrl, id, signal) {
    let response;
    try {
        response = await fetch(`${baseUrl.replace(/\/$/, '')}/identity/members/${encodeURIComponent(id)}`, { headers: { Accept: 'application/json' }, credentials: 'include', signal: signal ?? null });
    }
    catch {
        throw new MemberDetailApiError('unavailable', 'No pudimos consultar el socio.');
    }
    let payload;
    try {
        payload = await response.json();
    }
    catch {
        throw new MemberDetailApiError('invalid', 'El servidor devolvió una respuesta inválida.');
    }
    const message = typeof payload === 'object' &&
        payload !== null &&
        typeof payload.message === 'string'
        ? payload.message
        : 'No pudimos consultar el socio.';
    if (response.status === 400)
        throw new MemberDetailApiError('validation', message);
    if (response.status === 401)
        throw new MemberDetailApiError('unauthorized', message);
    if (response.status === 403)
        throw new MemberDetailApiError('forbidden', message);
    if (response.status === 404)
        throw new MemberDetailApiError('not-found', message);
    if (!response.ok)
        throw new MemberDetailApiError('unavailable', message);
    if (!isMemberDetailResponse(payload))
        throw new MemberDetailApiError('invalid', 'El contrato de detalle no es válido.');
    return payload;
}
